import { createRouter, createWebHashHistory } from "vue-router";
import App from "./App.vue";
import Resource from "./Resource.vue"

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {path: "/app",name: "App", component: App},
        {path: "/resource",name: "Resource", component: Resource},
    ],
});